const menus = [
    {
        id: 1,
        name: 'Trade',
        links: '/trade/BTCUSDT',
       
    },
    
    {
        id: 2,
        name: 'Markets ',
        links: '/markets'
    },
    {
        id: 3,
        name: 'Deposit',
        links: '/crypto-deposit',
      
    },
    {
        id: 4,
        name: 'Withdraw',
        links: '/crypto-withdrawal',
    },

    {
        id: 5,
        name: 'Wallet',
        links: '/wallet'
    },
    {
        id: 6,
        name: 'Launchpad',
        links: '/launchpad'
    },
    {
        id: 7,
        name: 'Staking',
        links: '/staking'
    },
    {
        id: 8,
        name: 'Airdrop',
        links: '/airdrop'
    },
    {
        id: 9,
        name: 'Coin Listing',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'Coin Listing',
                links: '/coin-listing'
            },
            {
                id: 2,
                sub: 'Official Authenticity',
                links: '/official-authenticity'
            },
           
           
        ],
    },
   
]

export default menus;